export default __webpack_public_path__ + "4fb63d5a5bcf2aa80650051ea63140c5.pdf";